import React, { useEffect, useState } from "react";

import { PostAvatar } from "./PostAvatar";
import { PostHeader } from "./PostHeader";
import { FullScreenVideo } from "@components/fullScreenVideo";
import { HotelActivityWrapper } from "./HotelActivityWrapper";
import { HotelFullScreenVideo } from "../../topHotels/HotelFullScreenVideo";
import { Modal } from "@components/shared";

import { MdOutlineClose, MdPlayArrow } from "react-icons/md";

import { languageCheck } from "@shared/functions";

import {
  ISpotTopExperiences,
  ISpotTopMustSee,
} from "../../../../../types/spotInfo";
import { ISpotToptHotels, Webposts } from "../../../../../types/spotTopHotels";

import { useTranslation } from "next-i18next";
import { useMobileDetect } from "@hooks/useMobileDetect";
import { useRouter } from "next/router";
import { events, track } from "@shared/tracking";
import { PostHeaderSearch } from "./PostHeaderSearch";

interface PostProps {
  posts: Webposts[];
  title: string;
  data: (ISpotTopMustSee)[];
  index: number;
  price: number;
  count: number;
  rating: number;
  handleCloseSwiper: () => void;
  id: string;
  automaticallyPlayVideo?: boolean;
}

export const PostSearch = ({
  posts,
  title,
  data,
  index,
  price,
  count,
  rating,
  handleCloseSwiper,
  id,
  automaticallyPlayVideo,
}: PostProps) => {
  const { isMobile } = useMobileDetect();
  const { t: translate } = useTranslation();
  const router = useRouter();

  const [postIndex, setPostIndex] = useState<number>(0);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const currentPost = posts[postIndex];
  const postsLength = posts.length;

  const trackVideoPlaying = () => {
    const _id = id.split("_")[0];
    track(events.PLAY_VIDEO_EVENT, {
      section:
        _id === "btnSpotTopExperienceMap"
          ? "experiences"
          : "places-to-visit"
         ,
      ...(_id === "btnSpotTopHotelsMap" && {
        city_id: router.query.id as string,
      }),
    });
  };

  useEffect(() => {
    const { experience_id } = router.query;
    if (automaticallyPlayVideo && !!experience_id) {
      setOpenModal(true);
    }
  }, []);



  const onExpandActivity = (activityId: number, activityIndex: number, cityId: string) => {
    // setExpandedActivity(`${activityId}-${activityIndex}`);
    // get url params

    const eventsPayload={
      city_id: cityId,
      place_to_visit_id: activityId,
       section:  "places-to-visit-search"
    };

    router.push({
      pathname: "/spotprofile/[id]/activity/[activityId]",
      query: {
        ...router.query,
        activityId,
        experience_id: "0",
        expand_activities:  "true",
        section: "places-to-visit-search",
      },
    });

    track(events.CHECK_ACTIVITY_DETAILS, {
      ...eventsPayload,
      activity_id: activityId.toString(),
    });
  };

  return (
    <div className={"w-full " + `${isMobile() ? "h-40" : "h-56"}`}>
      <div
        className="relative flex w-full h-full mt-4 bg-center bg-no-repeat bg-cover border-2 rounded-md bg-primary-color border-primary-color bg-black/50 "
        style={{
          backgroundImage: `url('${currentPost?.post?.thumbnail_url == null ? data[index]?.activity[0]?.discover_image : currentPost?.post?.thumbnail_url}')`,
          boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.3)",
        }}
        onClick={() => {
          if(currentPost?.post == null){
            onExpandActivity(data[index]?.activity[0]?.activity_id,index,data[index]?.city_id.toString())
          }
          else{
            setOpenModal(true), trackVideoPlaying();
          }
          
        }}
        id={id}
      >
        <div className="flex flex-col justify-between w-full h-full">
          <PostHeaderSearch
            title={title}
            postIndex={postIndex}
            setPostIndex={setPostIndex}
            postsLength={postsLength}
          />
          {currentPost?.post != null  && <div
            className={
              "w-11 h-11 absolute z-50 flex items-center justify-center  p-2 -translate-x-1/2 -translate-y-1/2 border border-gray-100 rounded-full bg-gray-900/60 top-1/2 left-1/2"
            }
            // onClick={() => setOpenModal(true)}
          >
            <MdPlayArrow className="w-full h-full text-gray-100" />
          </div>}
          <div className="flex flex-col px-1">
            {currentPost?.post != null  && <PostAvatar
              imgUrl={currentPost?.post?.User?.thumbnail}
              userName={currentPost?.post?.User?.username}
            />}

            {/* ACTIVITIY WRAPPER */}
            { (
              <div
                className={
                  " p-2 mb-1 bg-[#121212]/80 border border-gray-600 rounded-xl"
                }
              >
                <p
                  className={
                    " text-sm flex items-center justify-between px-1 py-0.3  font-semibold text-primary-color"
                  }
                >
                  <span>
                    {count}{" "}
                    <span className={"text-[14px] font-bold text-gray-100 "}>
                      {
                        data[index]?.spot_id
                          ? count > 1
                            ? translate("TITLE_ACTIVITIES")
                            : translate("TITLE_ACTIVITY")
                          : null
      
                      }
                    </span>
                    <span className="pl-1">
                      ({rating?.toFixed(1).replace(/\.0+$/, "")}/5)
                    </span>
                  </span>
                  <span className="ml-1 text-right">
                    <span className={" text-[12px] font-light text-white"}>
                      {translate("FROM")}
                    </span>
                    <span className={"text-[15px]"}>
                      {` ${isNaN(+price)|| price.toString() == '' ?  "0" : price}€`}
                    </span>
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>

        {/* CLOSE ICON */}
        <div
          className="absolute rounded-full -right-2 -top-3 bg-primary-color "
          onClick={() => handleCloseSwiper()}
        >
          <MdOutlineClose size={28} />
        </div>
      </div>
      <Modal isOpen={openModal}>
        
          <FullScreenVideo
            handleClose={() => setOpenModal(false)}
            exprience={{
              title: languageCheck(
   
                  data[index].english_name,
                  data[index].spanish_name,
                  data[index].french_name
              ),
              posts: data[index].webposts?.map(({ post }) => ({
                postId: post.post_id,
                url: post.fileStorage_url,
                thumbnailUrl: post.thumbnail_url,
                userId: post.user_id,
                username: post.User.username,
                userThumbnail: post.User.thumbnail,
              })),
              activities: data[index].activity.map((activity) => ({
                id: activity.activity_id,
                url: languageCheck(
                  activity.url_en,
                  activity.url_es,
                  activity.url_fr,
                  activity.url_ru
                ),
                name: languageCheck(
                  activity.name_en,
                  activity.name_es,
                  activity.name_fr,
                  activity.name_ru
                ),
                description: languageCheck(
                  activity.description_en,
                  activity.description_es,
                  activity.description_fr,
                  activity.description_ru
                ),
                address: languageCheck(
                  activity.address_en,
                  activity.address_es,
                  activity.address_fr,
                  activity.address_ru
                ),
                providerImgUrl: languageCheck(
                  activity.provider_en_url,
                  activity.provider_es_url,
                  activity.provider_fr_url,
                  activity.provider_ru_url
                ),
                score: languageCheck(
                  activity.score_en,
                  activity.score_es,
                  activity.score_fr,
                  activity.score_ru
                ),
                lang: languageCheck(
                  activity.activity_lang_en,
                  activity.activity_lang_es,
                  activity.activity_lang_fr,
                  activity.activity_lang_ru
                ),
                duration: languageCheck(
                  activity.duration_en,
                  activity.duration_es,
                  activity.duration_fr,
                  activity.duration_ru
                ),
                reviews: languageCheck(
                  activity.reviews_en,
                  activity.reviews_es,
                  activity.reviews_fr,
                  activity.reviews_ru
                ),
                freeCancelation: languageCheck(
                  activity.free_cancelation_en,
                  activity.free_cancelation_es,
                  activity.free_cancelation_fr,
                  activity.free_cancelation_ru
                ),
                originalPrice: languageCheck(
                  activity.original_price_en,
                  activity.original_price_es,
                  activity.original_price_fr,
                  activity.original_price_ru
                ),
                minimumPrice: languageCheck(
                  activity.minimum_price_en,
                  activity.minimum_price_es,
                  activity.minimum_price_fr,
                  activity.minimum_price_ru
                ),
                currency: activity.currency,
              })),
              experienceId:
               data[index].spot_id,
            }}
            section={
            "places-to-visit-search"
            }
          />
        
      </Modal>
    </div>
  );
};
